import React from "react";

function TowK23() {
  return <div>2023</div>;
}

export default TowK23;
